var map = {
	"./AppHeader_de.json": [
		15282,
		5282
	],
	"./AppHeader_en.json": [
		87962,
		7962
	],
	"./AppHeader_hy.json": [
		12922,
		2922
	],
	"./AppHeader_ru.json": [
		7788,
		7788
	],
	"./AppHeader_ua.json": [
		89775,
		9775
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 80897;
module.exports = webpackAsyncContext;